<template>
  <svg viewBox="0 0 24 24" v-on="$listeners">
    <path
      d="M11.293 5.707l5.293 5.293h-11.586c-0.552 0-1 0.448-1 1s0.448 1 1 1h11.586l-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l7-7c0.096-0.096 0.168-0.207 0.217-0.325 0.049-0.12 0.075-0.247 0.076-0.374 0.001-0.133-0.024-0.266-0.076-0.39-0.049-0.118-0.121-0.229-0.217-0.325l-7-7c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'arrow-right',
}
</script>